export default __webpack_public_path__ + "static/media/Helm of Wild Furor.420df0de.jpg";